import GoogleMap from '../google-map'

export default class StoreLocator extends GoogleMap {
	static title = 'storelocator'

	init() {
		super.init()
		this.maxReach = this.element.getAttribute('data-max-reach') || 50000

		this.mapSelector = '.storelocator__map'
		this.storesContainer = this.element.querySelector('.storelocator__stores')
		this.stores = Array.from(
			this.element.querySelectorAll('.storelocator__store')
		)
	}

	createInfoWindowContent(storeElement) {
		let storeContent = ''
		let storeName = storeElement.querySelector('.storelocator__store__name')
		let storeAddress = storeElement.querySelector('.storelocator__store__address')
		let storeInfo = storeElement.querySelector('.storelocator__store__info')

		if (storeName) {
			storeContent += storeName.innerText
		}

		if (storeAddress) {
			storeContent += '<br />' + storeAddress.innerText
		}

		if (storeInfo) {
			storeContent += '<br />' + storeInfo.innerText
		}

		if (storeContent === '') {
			storeContent = storeElement.innerText
		}

		return storeContent
	}

	load() {
		super.load()
		this.stores.forEach(store => {
			const latLng = {
				lat: parseFloat(store.getAttribute('data-latitude')),
				lng: parseFloat(store.getAttribute('data-longitude')),
			}
			const newMarker = this.createMarker(
				this.map,
				latLng,
				store.getAttribute('data-marker-id'),
				store.querySelector('.storelocator__store__name').innerText || '',
				this.createInfoWindowContent(store),
				store
			)

			this.markers.push(newMarker)
		})

		// go to user's current location
		this.element
			.querySelector('.storelocator__search__icon')
			.addEventListener('click', () => this.geolocationByGPS(), false)

		// on click of one of the stores in the list, go to its location
		Array.from(
			this.element.querySelectorAll('.storelocator__store__name')
		).forEach(store => {
			store.addEventListener(
				'click',
				event => this.navigateToMarker(event),
				false
			)
		})

		// search input
		this.element
			.querySelector('.storelocator__search__input')
			.addEventListener('keyup', event => this.getSearchResults(event))
	}

	getSearchResults(event) {
		const key = event.which || event.keyCode

		// on esc
		if (key === 27 || event.target.value === '') {
			this.stores.forEach(store => {
				store.classList.remove('storelocator__store--hidden')
			})
			this.map.setZoom(3)
			return
		}

		// on submit (press enter)
		if (key !== 13) {
			return
		}

		this.geolocationByUserInput(event.target.value)
	}

	handleGeolocation(result) {
		super.handleGeolocation()
		if (!result) {
			return
		}

		this.markers.forEach(marker => {
			if (
				marker.getPosition().lat() === 0 ||
				marker.getPosition().lng() === 0
			) {
				return
			}

			// the distance between the marker and the found location
			const distanceBetween = google.maps.geometry.spherical.computeDistanceBetween(
				new google.maps.LatLng(marker.position.lat(), marker.position.lng()),
				new google.maps.LatLng(
					result.geometry.location.lat(),
					result.geometry.location.lng()
				)
			)

			marker.domNode.setAttribute('data-distance', distanceBetween)
			if (distanceBetween > this.maxReach) {
				marker.domNode.classList.add('storelocator__store--hidden')
				return
			}

			marker.domNode.classList.remove('storelocator__store--hidden')
		})

		const sorted = this.stores.sort(StoreLocator.compareDistances)
		if (this.storesContainer) {
			sorted.forEach(e => this.storesContainer.appendChild(e))
		}

		this.map.setZoom(10)
	}

	static compareDistances(a, b) {
		return parseFloat(a.getAttribute('data-distance')) >
			parseFloat(b.getAttribute('data-distance'))
			? 1
			: -1
	}
}
